"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@material-ui/core/styles");
const material_kit_pro_react_1 = require("../../assets/jss/material-kit-pro-react");
const styles = (theme) => (0, styles_1.createStyles)({
    container: material_kit_pro_react_1.container,
    root: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(3),
        display: 'flex',
        flexDirection: 'column',
        minWidth: '100%'
    },
    backButton: {
        marginLeft: -theme.spacing(),
        '& span': {
            textTransform: 'none',
            color: theme.palette.text.secondary
        }
    },
    title: {
        marginTop: theme.spacing(2)
    },
    alertSubTitle: {
        marginTop: theme.spacing(1)
    },
    detailContainer: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2)
    },
    detailCardWrapper: {
        paddingRight: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        [theme.breakpoints.down('xs')]: {
            paddingBottom: theme.spacing(4)
        }
    },
    detailContainerCard: {
        position: 'relative',
        [theme.breakpoints.up('lg')]: {
            width: 350,
            height: 350,
            marginRight: theme.spacing(2)
        },
        [theme.breakpoints.only('md')]: {
            height: 320,
            width: 320
        },
        [theme.breakpoints.up('sm')]: {
            width: 350
        },
        [theme.breakpoints.only('xs')]: {
            width: '100%'
        },
        overflow: 'inherit',
        '& img': {
            objectFit: 'cover',
            width: '100%',
            height: '100%',
            [theme.breakpoints.up('lg')]: {
                width: 350,
                height: 350,
                marginRight: theme.spacing(2)
            }
        }
    },
    previewText: {
        position: 'absolute',
        top: '59%',
        left: '35%',
        fontSize: '20px',
        border: 'none',
        color: 'white',
        fontWeight: 500,
        textShadow: '0 0 10px rgba(0,0,0,0.8)'
    },
    overlay40: {
        filter: 'brightness(0.6)'
    },
    rewardPlayIcon: {
        position: 'absolute',
        top: '40%',
        left: '42%',
        height: '70px!important',
        width: '70px!important',
        cursor: 'pointer',
        transition: 'transform .5s ease-in-out',
        '&:hover': {
            transform: 'scale(1.3)'
        }
    },
    rewardDetailItem: {
        paddingBottom: theme.spacing(3)
    },
    rewardRedeemContainer: {
        marginTop: theme.spacing(2),
        display: 'flex',
        flexDirection: 'column',
        [theme.breakpoints.down('xs')]: {
            width: '100%'
        }
    },
    redeemButtonsRow: {
        display: 'flex',
        flexDirection: 'row'
    },
    rewardRedeemButton: {
        minWidth: '295px',
        minHeight: '50px',
        marginBottom: theme.spacing(2),
        [theme.breakpoints.down('xs')]: {
            width: '100%'
        }
    },
    claimButton: {
        backgroundColor: '#0082CA',
        color: theme.palette.common.white,
        '&:hover': {
            boxShadow: '0 2px 4px 0 #6198B7',
            backgroundColor: 'rgba(0,130,202,0.6)'
        }
    },
    rewardRedeemText: {
        [theme.breakpoints.down('xs')]: {
            justifyContent: 'center'
        }
    },
    largeIcon: {
        fontSize: '2rem',
        [theme.breakpoints.down('xs')]: {
            fontSize: '2rem'
        }
    },
    redeemModal: {
        width: '28em',
        [theme.breakpoints.down('xs')]: {
            width: '18.8em'
        },
        [theme.breakpoints.down('xs')]: {
            width: '17.5em'
        }
    },
    redeemModalDigitalDownloadContainer: {
        padding: theme.spacing(2),
        borderRadius: 8,
        backgroundColor: theme.palette.grey[200],
        textAlign: 'center'
    },
    redeemModalDigitalDownloadImg: {
        maxHeight: 80
    },
    redeemModalTextPoints: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        padding: theme.spacing(1)
    },
    redeemModalPoints: {
        marginBottom: theme.spacing()
    },
    redeemModalActions: {
        marginTop: theme.spacing(),
        marginBottom: theme.spacing(2),
        paddingTop: theme.spacing(3),
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2)
    },
    codeContainer: {
        padding: theme.spacing(),
        paddingTop: theme.spacing(2),
        paddingBottom: 0,
        margin: theme.spacing(),
        backgroundColor: theme.palette.common.black.getWithAlpha(0.05),
        borderRadius: 5,
        border: 1,
        borderColor: theme.palette.common.black.getWithAlpha(0.08)
    },
    code: {
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2),
        marginTop: theme.spacing(),
        wordBreak: 'break-all'
    },
    copyText: {
        color: theme.palette.text.secondary,
        textTransform: 'none',
        wordBreak: 'break-all'
    },
    copyIcon: {
        color: theme.palette.text.secondary,
        fontSize: 16,
        marginRight: theme.spacing()
    },
    redeemSuccessText: {
        marginTop: theme.spacing(2)
    },
    rewardRedeemDownloadButton: {
        minHeight: '50px',
        marginBottom: theme.spacing(2),
        [theme.breakpoints.down('xs')]: {
            width: '100%'
        },
        marginTop: theme.spacing(3)
    },
    redeemSuccessModalActions: {
        alignItems: 'center',
        justifyContent: 'center',
        padding: theme.spacing(2)
    },
    spacing: {
        paddingRight: theme.spacing()
    },
    extraDataSpace: {
        paddingBottom: theme.spacing(2)
    }
});
exports.default = styles;
//# sourceMappingURL=RewardDetailScreenStyle.js.map